import { useApolloClient } from '@apollo/client'
import { EmployeeLegalEntitiesFilterDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export type NumberInFilter = {
  type: 'in'
  label: string
  options: {
    cache?: boolean
    options:
      | Array<{ label: string; value: number }>
      | (() => Promise<Array<{ label: string; value: number }>>)
  }
}

export const useLegalEntityFilter = (): NumberInFilter => {
  const client = useApolloClient()

  return {
    label: i18n.t('employees.employees_list.filters.legal_entity'),
    type: 'in' as const,
    options: {
      cache: true,
      options: async () => {
        const { data } = await client.query({
          query: EmployeeLegalEntitiesFilterDocument,
          fetchPolicy: 'cache-first',
        })

        return data.companies.legalEntities.map((legalEntity) => ({
          label: legalEntity.legalName,
          value: legalEntity.id,
        }))
      },
    },
  }
}
